import React from 'react';
import { Button } from '@/components/ui/button';
import { LoadingSpinner } from '@/components/common/LoadingSpinner/LoadingSpinner';
import { useAuth } from '@/features/auth/hooks/useAuth';
import { LogOut } from 'lucide-react';

interface LogoutButtonProps {
  variant?: 'default' | 'ghost' | 'outline';
  size?: 'default' | 'sm' | 'lg' | 'icon';
  showIcon?: boolean;
  showText?: boolean;
  className?: string;
  onLogout?: () => void;
}

export const LogoutButton: React.FC<LogoutButtonProps> = ({
  variant = 'ghost',
  size = 'default',
  showIcon = true,
  showText = true,
  className,
  onLogout,
}) => {
  const auth = useAuth();

  const handleLogout = async () => {
    try {
      await auth.logout();
      onLogout?.();
    } catch (error) {
      console.error('Logout failed:', error);
    }
  };

  return (
    <Button
      variant={variant}
      size={size}
      onClick={handleLogout}
      disabled={auth.isLoading}
      className={className}
    >
      {auth.isLoading ? (
        <LoadingSpinner size="sm" />
      ) : (
        <>
          {showIcon && <LogOut className="h-4 w-4" />}
          {showText && (
            <span className={showIcon ? 'ml-2' : ''}>
              Sign out
            </span>
          )}
        </>
      )}
    </Button>
  );
};
